export default __webpack_public_path__ + "assets/a10be0664259206a1e0b911e78432ad9.png";